import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';

export const useChosenVariantDetailsStore = defineStore('chosenVariantDetailsStore', () => {
  const chosenStorage = ref(null)
  const chosenColor = ref(null)
  const chosenChannel = ref(null)
  const chosenInstallment = ref(null)
  const productDetails = ref({})

  return {
    chosenStorage,
    chosenColor,
    chosenChannel,
    chosenInstallment,
    productDetails
  }
})
